import { render, staticRenderFns } from "./BlockListView2.vue?vue&type=template&id=ecc8079c&scoped=true&"
import script from "./BlockListView2.vue?vue&type=script&lang=js&"
export * from "./BlockListView2.vue?vue&type=script&lang=js&"
import style0 from "./BlockListView2.vue?vue&type=style&index=0&id=ecc8079c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc8079c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecc8079c')) {
      api.createRecord('ecc8079c', component.options)
    } else {
      api.reload('ecc8079c', component.options)
    }
    module.hot.accept("./BlockListView2.vue?vue&type=template&id=ecc8079c&scoped=true&", function () {
      api.rerender('ecc8079c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/ubossOnePage/BlockListView2.vue"
export default component.exports